import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "../card/card";
import ConfirmationDlg from "../ConfirmationDlg";
import NormalSelect from "../form/HorizontalNormalSelect";
import { checklist as checklistAPI } from "../../api";
import { TaskActionItem } from "./TaskActionItem";

export const TaskAction = ({ value }) => {
  const [tasks, setTasks] = useState(value);

  useEffect(() => {
    setTasks(value);
  }, [value]);

  return (
    <Card>
      <CardHeader>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>Task List</div>
        </div>
      </CardHeader>
      <CardBody>
        <table
          style={{
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: ".5em 1em",
          }}
        >
          <thead>
            <tr>
              <th>No</th>
              <th>Task</th>
            </tr>
          </thead>
          <tbody>
            {tasks.map((ts, indexTask) => (
              <TaskActionItem key={indexTask} indexTask={indexTask} task={ts} />
            ))}
          </tbody>
        </table>
      </CardBody>
    </Card>
  );
};
